import React, { useEffect, useState } from "react"

const Bullet = ({
    id,
    defaultStyle = { width: '25px', height: '25px', padding: '4px', border: '1px solid #d8d8d8', borderRadius: '4px' },
    style,
    checked,
    onChange,
}) => {


    const [_checked, _setChecked] = useState(false);

    useEffect(() => {
        _setChecked(checked);
    }, [checked])

    return (
        <div
            id={id}
            aria-hidden="true"
            className="cursor-pointer flex-shrink-0"
            style={{ ...defaultStyle, ...style }}
            onClick={() => {
                if(onChange)
                {
                    onChange(!_checked);
                }
            }}
        >
            {_checked && <div className="bg-primary w-full h-full"></div>}
        </div>
    )

}

export default Bullet